/**
 * تهِ extra که خودش را معرفی می‌کند (game.go، fillTail): حالت آخرین عدد است؛ مسابقه امتیاز و بُردِ هر صندلی، همکاری
 * قلب و ستاره و نتیجه‌ی نقشه. در شمارش هم می‌آید، پس «دورِ N از M» پیش از go هم پیداست.
 */
export interface Tail {
  mode: number;
  /** دورهای تمام‌شده (همکاری: نقشه‌های تمام‌شده) و همه‌ی دورها. */
  round: number;
  rounds: number;
  points: number[];
  wins: number[];
  hearts: number;
  maxHearts: number;
  stars: number;
  fails: number;
  /** همکاری: نتیجه‌ی نقشه — ۱ تمام، ۰ شکست، −۱ هنوز. */
  result: number;
}

export function tailOf(extra: readonly number[], players: number): Tail {
  const at = (k: number) => extra[extra.length - k] ?? 0;
  const t: Tail = { mode: at(1), rounds: Math.max(1, at(2)), round: at(3), points: [], wins: [], hearts: 0, maxHearts: 0, stars: 0, fails: 0, result: -1 };
  if (extra.length < 5) return { ...t, mode: 0, rounds: 1, round: 0 }; // سرورِ کهنه: یک دور
  if (t.mode === 1) {
    [t.hearts, t.maxHearts, t.stars, t.fails, t.result] = [at(8), at(7), at(6), at(5), at(4)];
  } else {
    t.points = extra.slice(extra.length - 3 - 2 * players, extra.length - 3 - players);
    t.wins = extra.slice(extra.length - 3 - players, extra.length - 3);
  }
  return t;
}
